/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState } from "react";
import { AvGroup, AvField, AvForm } from "availity-reactstrap-validation";

import {
  Container,
  Content,
  Background,
  AnimationContainer,
  ForgotPassword,
} from "./Login.styles.js";

import logo from '../../../assets/logo.png'

import { useAuthentication } from "../../../hooks/useAuth";

export default function Login() {
  const { handleLogin } = useAuthentication();
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const emailRef = useRef(null);
  const passRef = useRef(null);

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      await handleLogin(emailRef.current.value, passRef.current.value);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Background />
      <Content>
        <AnimationContainer>
          <img
            style={{ height: 180 }}
            src={logo}
            alt="Infarma Sistemas"
          />
          <AvForm ref={formRef} onSubmit={handleSubmit}>
            <AvGroup>
              <AvField
                name="email"
                innerRef={emailRef}
                type="email"
                placeholder="Email"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Digite seu email.",
                  },
                  email: {
                    value: true,
                    errorMessage: "Digite um email válido.",
                  },
                }}
              />
              <AvField
                name="password"
                innerRef={passRef}
                type="password"
                placeholder="Senha"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Digite sua senha",
                  },
                }}
              />
            </AvGroup>
            <button type="submit" disabled={loading}>
              {loading ? "Aguarde..." : "Entrar"}
            </button>
            <ForgotPassword>   
              ou <a href='/forgot-password'>Esqueci a senha</a>
            </ForgotPassword>
          </AvForm>
        </AnimationContainer>
      </Content>
    </Container>
  );
}
